import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";

export default {
  DoGetInvoicePaymentRemainingNetAmountList(invoiceIdList) {
    let _input = {
      invoiceIdList: invoiceIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoicePaymentRemainingNetAmountList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNotePaymentRemainingNetAmountList(billingNoteIdList) {
    let _input = {
      billingNoteIdList: billingNoteIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetBillingNotePaymentRemainingNetAmountList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentGroupTransactionTableList(input) {
    let _input = {
      transactionIdList: input.transactionIdList,
      transactionType: input.transactionType,
    };
    return API.peakAPI
      .post("/api/Table/GetPaymentGroupTransactionTableList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNotePaymentRemainingNetAmountList(debitNoteIdList) {
    let _input = {
      debitNoteIdList: debitNoteIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetDebitNoteRemainingNetAmountList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceRemainingNetAmountListForEditBillingNote(input) {
    let _input = {
      invoiceIdList: input.invoiceIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceRemainingNetAmountListForEditBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteRemainingNetAmountListForEditBillingNote(input) {
    let _input = {
      debitNoteIdList: input.debitNoteIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI
      .post("/api/Table/GetDebitNoteRemainingNetAmountListForEditBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositRemainingNetAmountListForEditBillingNote(input) {
    let _input = {
      depositIdList: input.depositIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositRemainingNetAmountListForEditBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptRemainingNetAmountListForEditBillingNote(input) {
    let _input = {
      invoiceReceiptIdList: input.invoiceReceiptIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptRemainingNetAmountListForEditBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositRemainingNetAmountList(depositIdList) {
    let _input = {
      depositIdList: depositIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositRemainingNetAmountList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptRemainingNetAmountList(invoiceReceiptIdList) {
    let _input = {
      invoiceReceiptIdList: invoiceReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptRemainingNetAmountList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetVoidJournalDetailByJournalId(journalId) {
    let _input = {
      journalId: journalId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetVoidJournalDetailByJournalId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
